// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__desc[data-v-521d930c]{font-size:12px;font-weight:400;line-height:1.67;letter-spacing:normal}.text__desc.bold[data-v-521d930c]{font-weight:700}", ""]);
// Exports
module.exports = exports;
